import Vue from 'vue'
import http from "./helper/http-common";

Vue.prototype.$http = http;
Vue.config.devtools = true;
Vue.component('SwiperComponent', require('./components/swiper/SwiperComponent.vue').default);
new Vue({
}).$mount('#swiper-app'); 